export const aboutData = {
    title: "Who I am",
    description1: "My name's Stéphane. I'm a Fullstack and Cloud developer based in Nice, FR.",
    description2: "During the day I work as a contractor for local company and in my free time I am building my own products. I spent my leisure hours drawing, painting and practicing martial arts.",
    image: 1
}